import { useCallback, useContext } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { AjaxContext, formatListData, AppContext, UserContext } from 'commons-ui';

import { UserDetailsContext } from 'context/userDetails';
import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import { UserOpponentsDetailsFilters } from './constants';

const useService = () => {
	const { app } = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);
	const { permissionsConfig } = useContext(UserContext);
	const getUserOpponentDetails = useCallback(async (filters?: UserOpponentsDetailsFilters) => {
		const { appName } = app;
		const permission = _find(permissionsConfig, { actionName: ACTION.getUserOpponentDetails });
		const result = await postData({
			endpoint: `/dashboard/getUserOpponentDetails/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.userStats}-getUserOpponentDetails`,
			queryParams: {
				appName
			},
			body: {
				uid,
				fromToDate: [filters?.userOpponentsDetailsFrom, filters?.userOpponentsDetailsTill]
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});

		const data = _get(result, ['data', 'data'], []);

		return { rowCount: data.length, data: formatListData(data) };
	}, []);

	return { getUserOpponentDetails, uid };
};

export default useService;
